module.exports = {
	"subjectItem": "1stdibs Item Inquiry",
	"subjectItemNetPrice": "1stdibs Net Price",
	"subjectDealer": "1stdibs.com Dealer Inquiry",
	"contactDealerHeader": "Contact {dealer}",
	"header": "Contact {dealer}",
	"messagePlaceholder": "Request more information about this item.",
	"messagePlaceholderStorefront": "Ask the dealer a question.",
	"offerPerItem": "per item for",
	"labelOptIn": "Opt in to share your email address directly with {dealer}.",
	"optInInfo": "We keep your personal information private.",
	"labelEmail": "Your Email",
	"labelName": "Your Name",
	"labelMessage": "Your Message",
	"sendCta": "Send",
	"busyCta": "Sending...",
	"pretextPur": "I'm interested in this item. Can you please confirm the price?",
	"errorPriceFormat": "Please enter a number in format ###,###",
	"errorPriceFormatEur": "Please enter a number in format ###.###",
	"errorPositiveNumber": "Please enter a value greater than zero",
	"errorUnderListPrice": "Please enter an offer below the list price",
	"errorSpecialCharacters": "May not contain special characters",
	"errorValidEmail": "Please enter a valid email address",
	"errorRequired": "This field is required",
	"successHeader": "Thank you!",
	"successMessage": "Your message has been sent to {dealerName}. <br /> View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageHold": "Request and message submitted! <br /> You will be notified if the dealer places the piece on hold for you. Dealers typically respond within one day. <br /> View all your requests and messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageNetPriceHold": "Requests submitted! <br /> You will be notified when the dealer responds with the net price and if the dealer places the piece on hold for you. Dealers typically respond within one day. View all your messages in <a href='/my/conversations'>My Conversations</a>.",
	"successMessageOffer": "Your offer has been submitted and the dealer has 3 days to respond. View your offer details in <a href='/my/orders/' class='bomtLink'>My Orders</a>.",
	"viewAllYourMessagesIn": "View all your messages in ",
	"myConversations": "My Conversations",
	"successInfoHeader": "Stay Up-to-Date",
	"successInfoSubtext": "Follow to get weekly email alerts with new arrivals from this {dealerType}.",
	"noThanksCta": "No, thanks",
	"favoriteDealerCta": "FOLLOW DEALER",
	"labelMessageToggle": "Include a Message",
	"offerLowballTitle": "DON’T MISS OUT WITH A LOW OFFER",
	"makeOfferModalLinkPrompt": "Ready to negotiate? ",
	"makeOfferModalLinkCta": "Make an offer >",
	"serviceError": "An error occurred while processing your request. Please try again later.",
	"loading": "Loading",
	"holdRequestLabel": "Include a request to place this piece on hold",
	"holdRequestInfoChecked": "Please indicate for how long you are requesting a hold. If approved, this piece will be placed on hold exclusively for you.",
	"offerInfo": "The dealer may accept an offer below {price}.",
	"offerLowballMessage": "Your offer is substantially below list price and not likely to be considered. Starting the negotiation with a higher offer increases the likelihood of coming to agreement with the dealer.",
	"offerLowballChangeCta": "Increase Offer",
	"offerLowballContinueCta": "Continue",
	"labelOffer": "Make an Offer",
	"offerLowballLabelHeading": "Warning: ",
	"offerLowballLabel": "An offer significantly below the {type} price of {price} will likely be rejected. We recommend raising your offer.",
	"lowballListPriceOption": "Purchase now at list price",
	"lowballOtherOptionLabel": "Enter another offer",
	"lowballOptionAmountOff": "{amountOff} off, {percentOff}% discount",
	"originalOffer": "(original offer)",
	"placeholderPdp": "Request more information about this item.",
	"placeholderStorefront": "Ask the dealer a question.",
	"storeAddressByAppointmentOnly": "By appointment only",
	"address": "Address"
};


//////////////////
// WEBPACK FOOTER
// ./json/copy/contact-dealer.json
// module id = 754
// module chunks = 4 6 8 9